import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExternalLinkmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12.667 12.667H3.333V3.333H8V2H3.333C2.593 2 2 2.6 2 3.333v9.334C2 13.4 2.593 14 3.333 14h9.334C13.4 14 14 13.4 14 12.667V8h-1.333v4.667ZM9.333 2v1.333h2.394L5.173 9.887l.94.94 6.554-6.554v2.394H14V2H9.333Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgExternalLinkmin);
export { ForwardRef as ReactComponent };
